import React from 'react';

// Hero image
import heroCollage from './Images/Hero/photo-collage.jpg';

// Section images
import communityImage from './Images/People/community-image.jpg';
import immersiveImage from './Images/Immersive Theatre/immersive-theatre-1.jpg';

// Program placeholder images
import studioImage from './Images/Studios/studio-placeholder.jpg';
import venueImage from './Images/Venues/venue-placeholder.jpg';
import bsideImage from './Images/B-Side/bside-placeholder.jpg';
import galleryImage from './Images/Gallery/gallery-placeholder.jpg';
import vintageImage from './Images/Vintage/vintage.jpg';

// People placeholder images
import edPhoto from './Images/People/jude-kusnierz.jpg';
import artist1Photo from './Images/People/artist1-placeholder.jpg';
import artist2Photo from './Images/People/artist2-placeholder.jpg';
import artist3Photo from './Images/People/artist3-placeholder.jpg';
import inderPhoto from './Images/People/inder-nirwan.jpg';
import marcusPhoto from './Images/People/marcus-coldeway.jpg';
import tehyaPhoto from './Images/People/tehya-mackenzie.jpg';

// Board member photos
import gavynPhoto from './Images/People/gavyn-backus-new.jpg';
import justinPhoto from './Images/People/justin-headshot-updated.jpg';
import bradPhoto from './Images/People/brad-godin.jpg';
import toddPhoto from './Images/People/todd-headshot-updated.jpeg';
import naureenPhoto from './Images/People/naureen-headshot-updated.jpg';
import danielaPhoto from './Images/People/daniela-headshot-updated.jpeg';
import emilyPhoto from './Images/People/emily-davies-headshot-updated.jpg';

// Land acknowledgement
import falseCreekImage from './Images/LandAcknowledgement/false-creek.jpg';

// Partner logos
import viffLogo from './Images/Partners/viff-logo.webp';
import fiveXLogo from './Images/Partners/5x-logo.png';
import mercuryArtistsLogo from './Images/Partners/mercury-artists-logo.png';
import kiplingLogo from './Images/Partners/kipling-logo.jpg';
import focusEventsLogo from './Images/Partners/focus-events-logo.avif';
import getFundraisingLogo from './Images/Partners/get-fundraising.avif';

// ================================================
// BEAUMONT STUDIOS ANNUAL REPORT 2025
// ================================================

function App() {
  return (
    <div className="annual-report">
      {/* PAGE 1: COVER */}
      <Cover />

      {/* PAGE 2: LAND ACKNOWLEDGEMENT */}
      <LandAcknowledgement />

      {/* PAGE 3: ED LETTER */}
      <EDLetter />

      {/* PAGE 4: BOARD CHAIR LETTER */}
      <BoardChairLetter />

      {/* PAGE 5: SPACE CRISIS - Removed per Susan Holden feedback, moved to Impact Report */}

      {/* PAGES 6-7: MISSION & IMPACT */}
      <WhoWeAre />
      <AtAGlance />

      {/* SECTION 2: CHARITY STATUS MILESTONE */}
      <CharityMilestone />

      {/* PAGES 8-9: PROGRAMS */}
      <SectionDivider title="Our Programs" />
      <ProgramStudios />
      <ProgramVenues />
      <ProgramBSide />
      <ProgramImmersive />
      <ProgramGallery />
      <ProgramVintage />

      {/* PAGES 10-11: ARTIST PROFILES */}
      <SectionDivider title="Artist Voices" />
      <ArtistProfiles />

      {/* PAGE 12: EDI */}
      <SectionDivider title="Equity, Diversity & Inclusion" />
      <EDIPage />

      {/* PAGES 14-16: FINANCIALS */}
      <SectionDivider title="Financials" />
      <FinancialOverview />
      <FinancialExpenses />
      <FinancialVisualization />

      {/* PAGE 17: FUNDERS */}
      <Funders />

      {/* PAGE 18: GOVERNANCE & TEAM */}
      <SectionDivider title="Our Team" />
      <BoardAndStaff />
      <VolunteerRecognition />

      {/* PAGE 19: CAPITAL CAMPAIGN & LOOKING AHEAD */}
      <LookingAhead />

      {/* PAGE 20: CALL TO ACTION */}
      <CallToAction />

      {/* BACK COVER / FOOTER */}
      <Footer />
    </div>
  );
}

// ================================================
// COVER
// ================================================
function Cover() {
  return (
    <section className="hero">
      <img
        src={heroCollage}
        alt="Beaumont Studios photo collage"
        className="hero__background"
      />
      <p className="section-label">Annual Report</p>
      <h1 className="hero__title">The Beaumont Studios</h1>
      <p className="hero__subtitle">2025</p>
    </section>
  );
}

// ================================================
// LAND ACKNOWLEDGEMENT
// ================================================
function LandAcknowledgement() {
  return (
    <section className="section section--land-acknowledgement page-break" style={{padding: 0, position: 'relative', marginTop: '4rem'}}>
      {/* Full-bleed False Creek image */}
      <div style={{position: 'relative', width: '100%', height: '40vh', minHeight: '300px', overflow: 'hidden'}}>
        <img 
          src={falseCreekImage} 
          alt="False Creek and Vancouver skyline — the traditional territories of the xʷməθkʷəy̓əm, Sḵwx̱wú7mesh, and səlilwətaɬ Nations"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '50%',
          background: 'linear-gradient(to top, var(--concrete-void) 0%, transparent 100%)'
        }} />
      </div>
      
      {/* Content */}
      <div style={{padding: '3rem 4rem', backgroundColor: 'var(--concrete-void)'}}>
        {/* Title removed per Susan Holden feedback */}
        <div className="land-ack-copy">
          <p style={{fontSize: '1.25rem', lineHeight: '1.8', color: 'var(--gallery-cream)', marginBottom: '1.5rem'}}>
            We operate on the unceded territories of the xʷməθkʷəy̓əm (Musqueam), 
            Sḵwx̱wú7mesh (Squamish), and səlilwətaɬ (Tsleil-Waututh) Nations.
          </p>
          
          <p style={{fontSize: '1rem', lineHeight: '1.8', color: 'var(--gallery-cream)', marginBottom: '2rem'}}>
            We recognize that this acknowledgement carries responsibility. As a community arts space, 
            we aim to honour that responsibility by supporting artists, audiences, and neighbours, 
            and by staying accountable to the communities whose lands make this work possible.
          </p>
          
          <p style={{fontSize: '0.875rem', lineHeight: '1.7', color: 'var(--gallery-cream)', borderTop: '1px solid var(--surface-elevated)', paddingTop: '1.5rem'}}>
            False Creek, visible in the image above, is part of the tidal inlet known in 
            hən̓q̓əmin̓əm̓ as <em>sńəẃey̓əɬ</em> (pronounced snuh-WAY-uth), 
            which has been a place of gathering, travel, and exchange for the Coast Salish 
            peoples since time immemorial.
          </p>
        </div>
      </div>
    </section>
  );
}

// ================================================
// ED LETTER
// ================================================
function EDLetter() {
  return (
    <section className="section page-break">
      <p className="section-label">From the Executive Director</p>
      <h2>A Year of Transformation</h2>
      
      {/* Top section: 2-column grid with opening paragraphs + photo */}
      <div className="grid grid--2">
        <div style={{display: 'flex'}}>
          <div className="pull-quote" style={{marginTop: 0, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <p className="pull-quote__text">
              Writing this letter at the end of each year is usually a time for quiet reflection. This year, after spending much of it spinning plates, it feels more like a moment to finally catch my breath, pause, and measure just how far we've actually run.
            </p>
            <p className="pull-quote__text">
              A few years ago, the word used too often was pivot. If I never hear that word again, it will be too soon. But in hindsight, those frantic months of constant shifting reshaped how we operate in fundamental ways. They proved that the Beaumont community is headstrong, creative, and impossible to break.
            </p>
            <p className="pull-quote__text">
              This year, I've chosen the phrase Forging a Pathway. We moved into 2025 with a level of focus and determination unlike anything before. We stopped reacting and started deliberately plotting our course toward securing our future forever home. We shifted from "survival mode" into "legacy mode."
            </p>
            <p className="pull-quote__text">
              A significant step along that path was being approved as a registered charity. Yes, it was deeply involved, required an enormous amount of effort, and came with what felt like an endless mountain of paperwork, but it was a strategic level-up. It strengthened our governance and signaled clearly to the philanthropic community that we are ready for serious, long-term partnership. We aren't just a unique, creative building anymore; we are an institution.
            </p>
          </div>
        </div>
        <img
          src={edPhoto}
          alt="Jude Kusnierz, Executive Director"
          className="section-image"
          style={{objectFit: 'cover', height: '100%'}}
        />
      </div>

      {/* Bottom section: Full-width remaining paragraphs */}
      <div style={{marginTop: '3rem'}}>
        <div className="pull-quote pull-quote--full-width-text">
          <p className="pull-quote__text">
            Despite all this serious future planning, we still made space for the creativity and joy we are known for, and in fact, we grew on it. This year, we launched our newest flagship production, Art Incognito, alongside the return of our Fall Immersive Theatre productions and Summer Socials. We also continued meaningful collaborations with long-standing partners including Focus Events (Candy), Mercury Artists (New Year's), 5x, and the Vancouver International Film Festival. There are simply too many to mention them all, thinking about the creatives I get to work alongside here makes my heart the happiest.
          </p>
          <p className="pull-quote__text">
            Looking ahead, the pathway is clear. We are walking into the coming year with intention, working toward a future where The Beaumont is woven permanently into Vancouver's cultural fabric. I am proud of what we have built, honoured to share this annual report, and in constant awe of what this community continues to bring to life.
          </p>
          <p className="pull-quote__text">
            None of this happens by magic, though at times it does feel like we are a group of unicorns riding rainbows. In all seriousness, it happens because of the deeply committed people who fuel this place: my colleagues, our board of directors, volunteers, front-line staff, resident artists, show producers, performers, and the many guests who fill these halls with energy. I am profoundly grateful to also call many of them friends, as they are truly part of an extended creative family. I look forward to continuing this work together with everyone as we shape what comes next.
          </p>
          <p className="pull-quote__text">
            I would also be remiss not to acknowledge those who have supported this work we do, from behind the scenes: our funders, donors, philanthropists, monthly contributors, and sponsors. This generosity is what makes this work possible, and that continued belief in the value of culture, community, and permanence will carry the Beaumont forward.
          </p>
          <p className="pull-quote__text">
            Thank you
          </p>
        </div>
        <p style={{marginTop: '2rem'}}>
          <strong>Jude Kusnierz</strong><br />
          <span style={{color: 'var(--ink-muted)'}}>Executive Director</span>
        </p>
      </div>
    </section>
  );
}

// ================================================
// BOARD CHAIR LETTER
// ================================================
function BoardChairLetter() {
  return (
    <section className="section section--cream page-break">
      <p className="section-label">From the Board President</p>
      <h2>Governance & Stewardship</h2>
      <div className="grid grid--2">
        <img
          src={gavynPhoto}
          alt="Gavyn Backus, Board President"
          className="section-image"
          style={{objectFit: 'cover', height: '100%', minHeight: '400px'}}
        />
        <div>
          <p>
            Twenty-two years ago, standing in her newly leased industrial space in Mount Pleasant, a glass artist looked toward the North Shore mountains and named this place Beaumont: "beautiful mountain." That view is mostly gone now, swallowed by the skyline that rose around us, but what took root inside these walls has proven far more enduring than any vista.
          </p>
          <p>
            I cannot fault those with a longer Beaumont-tenure for rolling their eyes at my opening statement, as I have perhaps taken a few creative liberties, but I felt that it was a fun "origin" story that conveys an ongoing theme for our organization—perseverance.
          </p>
          <p>
            This past year, The Beaumont Studios achieved charitable status in Canada—a milestone that fundamentally reshapes our organization's future. This transition was not merely administrative. It reflects management's and the board's commitment to building an institution that can weather whatever Vancouver throws at it next, and it positions us to pursue our "forever home".
          </p>
          <p>
            Property taxes in this city have tested us. The pandemic tested us. But here we are, still standing, still opening our doors to more than 100 artists, and still hosting educational and whimsical workshops, exhibitions, and community gatherings that make this place hum.
          </p>
          <p>
            The board's role in launching our organizational restructuring has been a challenging yet fulfilling experience. We have worked with management and other advisors to ensure that governance structures are sound, that financial stewardship reflects the values of the creative community we serve, and that our strategic direction keeps one foot planted in the present while the other steps toward something more permanent. We are building not just for ourselves, but for the artists who haven't found us yet and Vancouver's creative community as a whole.
          </p>
          <p>
            To our donors, members, and partners: thank you. You've made it possible to imagine what comes next and we greatly value your continuing support. We are just getting started!
          </p>
          <p style={{marginTop: '1.5rem'}}>
            With gratitude,
          </p>
          <p>
            <strong>Gavyn Backus</strong><br />
            <span style={{color: 'var(--ink-muted)'}}>Chair/President, Board of Directors</span>
          </p>
        </div>
      </div>
    </section>
  );
}

// Space Crisis component moved to SpaceCrisis-IMPACT-REPORT.jsx for future impact report use.

// ================================================
// WHO WE ARE
// ================================================
function WhoWeAre() {
  return (
    <section className="section">
      <p className="section-label">Who We Are</p>
      <h2>Many Communities, One Roof (Okay, Two)</h2>
      <img
        src={communityImage}
        alt="Beaumont Studios community gathering"
        className="section-image section-image--full"
      />
      <div className="grid grid--2" style={{marginTop: '2rem'}}>
        <p>
          The Beaumont was the first of its kind to establish a large-scale cultural hub 
          in Vancouver's Mount Pleasant neighbourhood over 20 years ago. Spanning 22,000 
          square feet of creative infrastructure across 316 and 326 West 5th Avenue, it 
          was built to support artists, creative professionals, and community-led 
          programming at scale.
        </p>
        <p>
          Today, The Beaumont provides affordable studio space for artists, four versatile 
          event and performance venues, and platforms for creative expression across 
          disciplines. But more than a building, we're a convergence point: artists work 
          here, audiences gather here, and culture is made live. Everyone who comes through 
          our doors brings their own community. Together, they make up ours.
        </p>
      </div>
    </section>
  );
}

// ================================================
// AT A GLANCE
// ================================================
function AtAGlance() {
  const heroStat = { number: '533', label: 'Events Hosted in 2025' };

  const supportingStats = [
    { number: '98', label: 'Artists, 100% Occupancy' },
    { number: '2,100', label: 'Attendees (+40% vs 2024)' },
    { number: '110+', label: 'Radio Shows/Month' },
  ];

  return (
    <section className="section section--cream">
      <p className="section-label">2025 At A Glance</p>
      <h2>The Year in Numbers</h2>

      {/* Hero stat - big and prominent */}
      <div className="hero-stat" style={{textAlign: 'center', marginBottom: '2rem'}}>
        <p className="stat-number" style={{fontSize: 'clamp(5rem, 15vw, 10rem)', marginBottom: '0.5rem'}}>
          {heroStat.number}
        </p>
        <p className="stat-label" style={{fontSize: '1rem'}}>{heroStat.label}</p>
      </div>

      {/* Supporting stats */}
      <div className="grid grid--stats">
        {supportingStats.map((stat, index) => (
          <div key={index} className="stat-card stat-card--centered">
            <p className="stat-number">{stat.number}</p>
            <p className="stat-label">{stat.label}</p>
            {stat.highlight && (
              <p className="stat-label" style={{color: 'var(--neon-magenta)', marginTop: '0.25rem'}}>
                {stat.highlight}
              </p>
            )}
          </div>
        ))}
      </div>

      {/* Bottom row with financial highlight */}
      <div className="at-a-glance-strip" style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '4rem',
        marginTop: '1.5rem',
        paddingTop: '1.5rem',
        borderTop: '1px solid var(--steel)'
      }}>
        <div className="stat-card stat-card--centered">
          <p className="stat-number at-a-glance-strip__number" style={{color: 'var(--neon-magenta)'}}>$107K</p>
          <p className="stat-label">In Government Grants</p>
        </div>
        <div className="stat-card stat-card--centered">
          <p className="stat-number at-a-glance-strip__number">216</p>
          <p className="stat-label">Event Producers Served</p>
        </div>
        <div className="stat-card stat-card--centered">
          <p className="stat-number at-a-glance-strip__number">3,671</p>
          <p className="stat-label">Venue Hours Booked</p>
        </div>
      </div>
    </section>
  );
}

// ================================================
// CHARITY MILESTONE
// ================================================
function CharityMilestone() {
  return (
    <section className="milestone page-break">
      <div className="milestone__badge">NEW IN 2025</div>
      <p className="milestone__year">2025</p>
      <h2 className="milestone__title">We Became a Registered Charity</h2>
      <p className="milestone__description">
        This milestone reflects two decades of commitment to Vancouver's creative 
        community. Charitable status enables tax receipting for donors, opens the door 
        to foundation grants and major gifts, and positions us for the capital campaign 
        ahead. It signals organizational maturity, accountability, and a deepened 
        commitment to our mission of preserving affordable cultural space.
      </p>
      <div className="milestone__benefits">
        <div className="milestone__benefit">
          <span className="milestone__benefit-icon">✓</span>
          <span>Tax Receipts for Donors</span>
        </div>
        <div className="milestone__benefit">
          <span className="milestone__benefit-icon">✓</span>
          <span>Foundation Grant Access</span>
        </div>
        <div className="milestone__benefit">
          <span className="milestone__benefit-icon">✓</span>
          <span>Capital Campaign Ready</span>
        </div>
      </div>
    </section>
  );
}

// ================================================
// SECTION DIVIDER
// ================================================
function SectionDivider({ title }) {
  return (
    <div className="section--full section--dark" style={{padding: '3rem 2rem', marginTop: '3rem'}}>
      <div style={{maxWidth: 'var(--content-max-width)', margin: '0 auto'}}>
        <h2 style={{marginBottom: 0}}>{title}</h2>
      </div>
    </div>
  );
}

// ================================================
// PROGRAM: STUDIOS
// ================================================
function ProgramStudios() {
  return (
    <section className="section">
      <div className="program-card">
        <p className="section-label">Program</p>
        <h3>Artist Studios & Open Studios</h3>
        <div className="grid grid--2">
          <div>
            <p>
              One of our core mandates is to keep studio rents below market, lowering financial 
              barriers for working artists and enabling safe, long-term space for professional 
              practice. For over twenty years, Beaumont Studios has operated at nearly 100% 
              occupancy, demonstrating the sustained demand for affordable, stable studio space.
            </p>
            <p>
              But what truly defines Beaumont is the environment cultivated within it. Studios are 
              deliberately designed to be visible to one another through large interior windows, 
              allowing creative process and not just finished work to be seen by fellow artists, 
              clients and the public. This transparency creates organic opportunities for shared 
              exposure, neighbourly growth, and the kind of long-term creative relationships that 
              develop through proximity, time, and mutual visibility. Artists mentor one another, 
              collaborate across disciplines, and cross-pollinate their client networks, strengthening 
              both individual practices and reinforcing the broader cultural ecosystem.
            </p>
            <div style={{
              borderLeft: '4px solid var(--neon-cyan)',
              padding: '1rem',
              marginTop: '1rem',
              backgroundColor: 'var(--gallery-cream)'
            }} className="stat-strip stat-strip--light stat-strip--3">
              <div className="stat-strip__grid stat-strip__grid--3">
                <div className="stat-card">
                  <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>45</p>
                  <p className="stat-label">Studios</p>
                </div>
                <div className="stat-card">
                  <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>98</p>
                  <p className="stat-label">Resident Artists</p>
                </div>
                <div className="stat-card">
                  <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>100%</p>
                  <p className="stat-label">Occupancy</p>
                </div>
              </div>
            </div>
          </div>
          <img
            src={studioImage}
            alt="Artist studio workspace"
            className="section-image"
          />
        </div>
      </div>
    </section>
  );
}

// ================================================
// PROGRAM: VENUES
// ================================================
function ProgramVenues() {
  return (
    <section className="section section--cream">
      <div className="program-card" style={{borderBottom: 'none'}}>
        <p className="section-label">Program</p>
        <h3>Venue Rentals</h3>
        <div className="grid grid--2 program-split-row">
          {/* Image on LEFT for variety */}
          <img
            src={venueImage}
            alt="Event venue space"
            className="section-image"
          />
          <div>
            <p>
              Our four venue spaces host an extraordinary range of cultural activity: from 
              live performances and community gatherings to weddings, mitzvahs, celebrations 
              of life, and everything in between. Each space has its own character, and on 
              busy weeks, all four run simultaneously from morning load-ins to late-night strikes.
            </p>
            <p>
              We're available 24 hours a day, 365 days a year. The result: 533 events in 2025, 
              serving 216 unique producers across 3,671 booked hours.
            </p>
            <p>
              Venue rentals are one of three engines sustaining the Beaumont ecosystem, generating 
              earned revenue that directly supports our studios, programming, and affordability 
              mandate. 2025 saw strong demand for culturally specific events, including South 
              Asian celebrations (5X Festival) and 2SLGBTQIA+ community gatherings.
            </p>
          </div>
        </div>

        <div className="program-stat-band">
          <div style={{
            borderLeft: '4px solid var(--neon-cyan)',
            padding: '1rem',
            backgroundColor: 'var(--gallery-cream)'
          }} className="stat-strip stat-strip--light stat-strip--4">
            <div className="stat-strip__grid stat-strip__grid--4">
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>533</p>
                <p className="stat-label">Events Hosted</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>3,671</p>
                <p className="stat-label">Venue Hours Booked</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>216</p>
                <p className="stat-label">Event Producers Served</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>~252</p>
                <p className="stat-label">Public Programs</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Partner Testimonials */}
        <div style={{marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--steel)'}}>
          <h4 style={{marginBottom: '1.5rem'}}>Partner Voices</h4>
          <div className="grid grid--2">
            <div className="pull-quote">
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '1rem'}}>
                <img 
                  src={fiveXLogo}
                  alt="5X Festival logo"
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    flexShrink: 0,
                    backgroundColor: 'white'
                  }}
                />
                <div style={{flex: 1}}>
                  <p className="pull-quote__text">
                    "Beaumont has been an essential partner for 5X Festival since 2018. Their spaces provide the flexibility and cultural authenticity we need to create meaningful experiences for our community. Beyond just being a venue, Beaumont understands what we're trying to build and supports our vision in ways that go far beyond a typical rental relationship."
                  </p>
                  <p className="caption" style={{marginTop: '1rem'}}>
                    <strong>Sahil Mroke</strong>, Art Director<br />
                    5X Festival — Partner since 2018
                  </p>
                </div>
              </div>
            </div>
            <div className="pull-quote">
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '1rem'}}>
                <img 
                  src={viffLogo}
                  alt="VIFF logo"
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    flexShrink: 0,
                    backgroundColor: 'white'
                  }}
                />
                <div style={{flex: 1}}>
                  <p className="pull-quote__text">
                    "It is such a pleasure working with the team at The Beaumont. The space is creative and flexible, supported by accommodating and professional staff - the best balance in the world of event venues."
                  </p>
                  <p className="caption" style={{marginTop: '1rem'}}>
                    <strong>Brie Koniczek</strong>, Senior Operations Manager<br />
                    Vancouver International Film Festival — Partner since 2022
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// PROGRAM: B-SIDE RADIO
// ================================================
function ProgramBSide() {
  return (
    <section className="section">
      <div className="program-card">
        <p className="section-label">Program</p>
        <h3>B-Side Radio</h3>
        <div className="grid grid--2 program-split-row">
          <div>
            <p>
              B-Side Radio is a 24/7 community-driven streaming platform anchored in 
              Vancouver's DJ and music culture. Nearly 100 active hosts broadcast everything 
              from electronic and hip-hop to ambient, jazz, and beyond, sharing work, building 
              community, and amplifying emerging scenes.
            </p>
            <p>
              In 2025, we broadcast over 1,300 shows across 2,800+ hours. We also strengthened 
              community standards through formal host agreements that reinforce safety, 
              inclusion, and shared accountability. The result: a platform where local talent 
              thrives and audiences tune in from around the world.
            </p>
          </div>
          <img
            src={bsideImage}
            alt="B-Side Radio studio"
            className="section-image"
          />
        </div>

        <div className="program-stat-band">
          <div style={{
            borderLeft: '4px solid var(--neon-cyan)',
            padding: '1rem',
            backgroundColor: 'var(--gallery-cream)'
          }} className="stat-strip stat-strip--light stat-strip--4">
            <div className="stat-strip__grid stat-strip__grid--4">
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>1,322</p>
                <p className="stat-label">Shows Broadcast</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>2,821</p>
                <p className="stat-label">Broadcast Hours</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>98</p>
                <p className="stat-label">Active Hosts</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem'}}>8K+</p>
                <p className="stat-label">Online Followers</p>
              </div>
            </div>
          </div>
          <p className="caption program-stat-band__caption">
            8,000 Twitch followers • 750 YouTube subscribers
          </p>
        </div>
      </div>
    </section>
  );
}

// ================================================
// PROGRAM: IMMERSIVE THEATRE
// ================================================
function ProgramImmersive() {
  return (
    <section className="section section--dark page-break">
      <div className="program-card" style={{borderColor: 'var(--steel)'}}>
        <p className="section-label" style={{color: 'var(--neon-magenta)'}}>Headline</p>
        <h3>Theatre of the Damned</h3>
        <p className="section-label" style={{marginTop: '-0.5rem', marginBottom: '1.5rem'}}>
          Fall Immersive Programming
        </p>
        <div className="grid grid--2 program-split-row">
          <div>
            <p style={{color: 'var(--gallery-paper)'}}>
              A seasonal, high-impact cultural programming period that blends performance,
              immersive theatre, and atmosphere, designed to be fun, distinctive, and financially
              meaningful for the organization.
            </p>
            <p style={{color: 'var(--gallery-paper)'}}>
              2025 delivered a concentrated, sold-out seasonal run that brought new audiences
              into the building. We provided paid opportunities for 40 local performers and creatives,
              platforming emerging talent and reinforcing our identity as a place where culture is made live.
            </p>
            <div className="pull-quote pull-quote--magenta" style={{backgroundColor: 'var(--concrete-mid)'}}>
              <p className="pull-quote__text" style={{color: 'var(--gallery-paper)'}}>
                "40% attendance growth year-over-year"
              </p>
            </div>
          </div>
          <img
            src={immersiveImage}
            alt="Theatre of the Damned performance"
            className="section-image"
            style={{border: '2px solid var(--steel)'}}
          />
        </div>

        <div className="program-stat-band">
          <div style={{
            borderLeft: '4px solid var(--neon-magenta)',
            padding: '1rem',
            backgroundColor: 'var(--concrete-mid)'
          }} className="stat-strip stat-strip--dark stat-strip--4">
            <div className="stat-strip__grid stat-strip__grid--4">
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem', color: 'var(--neon-magenta)'}}>12</p>
                <p className="stat-label">Nights (Sold Out)</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem', color: 'var(--neon-magenta)'}}>2,100</p>
                <p className="stat-label">Attendees</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem', color: 'var(--neon-magenta)'}}>40</p>
                <p className="stat-label">Artists Engaged</p>
              </div>
              <div className="stat-card">
                <p className="stat-number stat-strip__number" style={{marginBottom: '0.25rem', color: 'var(--neon-magenta)'}}>+40%</p>
                <p className="stat-label">YoY Growth</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// PROGRAM: GALLERY
// ================================================
function ProgramGallery() {
  return (
    <section className="section">
      <div className="program-card">
        <p className="section-label">Program</p>
        <h3>B1 Gallery</h3>
        <div className="grid grid--2">
          <div>
            <p>
              An in-house gallery program that provides exhibition opportunities for artists
              and connects studio culture to public-facing engagement. The gallery is a low-barrier
              entry point for both artists and audiences—prioritizing access and opportunity while
              reinforcing the Beaumont as a living cultural hub.
            </p>
            <p>
              In 2025, we presented five exhibitions—each carefully curated to spotlight 
              emerging and underrepresented artists. Quality over quantity: every show 
              received the attention it deserved. In 2026, we're scaling up to ten 
              exhibitions as the program matures.
            </p>
            <div style={{
              borderLeft: '4px solid var(--neon-cyan)',
              padding: '1rem',
              marginTop: '1rem',
              backgroundColor: 'var(--gallery-cream)'
            }}>
              <div style={{display: 'flex', gap: '2rem', justifyContent: 'space-between'}}>
                <div className="stat-card">
                  <p className="stat-number" style={{fontSize: '2.5rem', marginBottom: '0.25rem'}}>5</p>
                  <p className="stat-label">Exhibitions</p>
                </div>
                <div className="stat-card">
                  <p className="stat-number" style={{fontSize: '2.5rem', marginBottom: '0.25rem'}}>5</p>
                  <p className="stat-label">Artists Shown</p>
                </div>
                <div className="stat-card">
                  <p className="stat-number" style={{fontSize: '2.5rem', marginBottom: '0.25rem'}}>10</p>
                  <p className="stat-label">2026 Target</p>
                </div>
              </div>
            </div>
          </div>
          <img
            src={galleryImage}
            alt="B1 Gallery exhibition"
            className="section-image"
          />
        </div>
      </div>
    </section>
  );
}

// ================================================
// PROGRAM: VINTAGE
// ================================================
function ProgramVintage() {
  return (
    <section className="section section--cream">
      <div className="program-card" style={{borderBottom: 'none'}}>
        <p className="section-label">Program</p>
        <h3>Beaumont V!ntage</h3>
        <div className="grid grid--2">
          {/* Image on LEFT for variety */}
          <img
            src={vintageImage}
            alt="Beaumont V!ntage shop"
            className="section-image"
          />
          <div>
            <p>
              Beaumont V!ntage is our community‑driven social enterprise advancing sustainability 
              and local economic resilience. Reimagined in 2025, it diverts quality clothing from 
              landfill and offers emerging designers affordable space to build skills and income.
            </p>
            <p>
              Designers contribute volunteer hours that help operate the shop, and all proceeds 
              are reinvested into Beaumont's charitable programs.
            </p>
            <div style={{
              borderLeft: '4px solid var(--neon-cyan)',
              padding: '1rem',
              marginTop: '1rem',
              backgroundColor: 'var(--gallery-cream)'
            }}>
              <div style={{display: 'flex', gap: '2rem'}}>
                <div className="stat-card">
                  <p className="stat-number" style={{fontSize: '2.5rem', marginBottom: '0.25rem'}}>8</p>
                  <p className="stat-label">Rack Designers</p>
                </div>
                <div className="stat-card">
                  <p className="stat-number" style={{fontSize: '2.5rem', marginBottom: '0.25rem'}}>+20%</p>
                  <p className="stat-label">2026 Revenue Goal</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// ARTIST PROFILES
// ================================================
function ArtistProfiles() {
  const artists = [
    {
      name: 'Inder Nirwan – Kahani Pictures',
      medium: 'Filmmaking',
      since: '2015',
      quote: 'The ebbs and flows of running a small creative agency in such an expensive city can get spicy. Having the Beaumont as our home gives us a sense of comfort and security knowing that our shared values supersede the kind of transactional relationship we would expect anywhere else. I feel welcome here and it means a lot.',
      photo: inderPhoto
    },
    {
      name: 'Marcus Coldeway – NEON Coast',
      medium: 'Abstract and Graffiti Artist & Artistic Director',
      since: '2020',
      quote: 'In 2020, joining Beaumont Studios meant more to me than just finding a place to work—it felt like finding oxygen. At a time when the world felt paused and uncertain, Beaumont was a space for art, conversation, and possibility. It was a space where community mattered, where events spark ideas, and where simply being around other creators reminded you why you make things in the first place. As an artist and culture builder, that constant hum of energy is everything. Walking into the studio feeds the soul and fills the heart; sometimes without even picking up a brush. Beaumont is your home base, your playground, your coffee shop, your gallery, and your late-night think tank all rolled into one. Whatever your craft, Beaumont doesn\'t just give you space; it gives you belonging.',
      photo: marcusPhoto
    },
    {
      name: 'Tehya Mackenzie',
      medium: 'Mixed Media Artist',
      since: '2019',
      quote: 'I can\'t say enough about what the Beaumont means to not just me personally, but my art practice as well. The B is a home to so many of us for whom creativity is our livelihood, but also is a community for us to create connections. A shared knowledge of the specialness of this space means the community is kind, vibrant, and welcoming. Being able to walk here from my home, have (mental and physical!) space to create, be greeted by friendly faces and a good coffee surrounded by art in the gallery genuinely makes my life better.',
      photo: tehyaPhoto
    }
  ];

  return (
    <section className="section page-break">
      <p className="section-label">Artist Voices</p>
      <h2>Stories from Our Studios</h2>
      <div className="artist-profiles">
        {artists.map((artist, index) => (
          <div
            key={index}
            className="artist-profile"
            style={{borderBottom: index < artists.length - 1 ? '1px solid var(--steel)' : 'none'}}
          >
            <img
              src={artist.photo}
              alt={artist.name}
              className="artist-profile__image"
            />
            <div className="artist-profile__content">
              <h3 className="artist-profile__name" style={{marginBottom: '0.25rem'}}>{artist.name}</h3>
              <p className="caption artist-profile__meta" style={{marginBottom: '1rem'}}>
                {artist.medium} • Studio tenant since {artist.since}
              </p>
              <div className="pull-quote artist-profile__quote" style={{margin: '1rem 0'}}>
                <p className="pull-quote__text">"{artist.quote}"</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ================================================
// EDI PAGE
// ================================================
function EDIPage() {
  return (
    <section className="section page-break edi-section">
      <p className="section-label edi-kicker">Our Commitment</p>
      <div className="grid grid--2 edi-grid">
        <div className="edi-copy">
          <p>
            Beaumont has always been a space where artists and communities who struggle to 
            find room elsewhere can gather, create, and belong. We don't just talk about 
            inclusion: we practice it daily through accessible pricing, open programming, 
            and a culture that welcomes first and asks questions later.
          </p>
          <p>
            We recognize that systemic barriers have historically excluded many communities 
            from arts spaces. We're committed to doing better: building relationships, 
            showing up consistently, and being accountable for our impact.
          </p>
          <h3 style={{marginTop: '2rem'}}>2025 Initiatives</h3>
          <ul>
            <li>Implemented Board EDI Objectives framework</li>
            <li>Established B-Side Radio Community Agreements reinforcing safety, inclusion, and shared accountability</li>
            <li>Hosted culturally specific events and 2SLGBTQIA+ community gatherings as part of our broader annual programming</li>
            <li>Our Board of Directors brings together a range of lived experiences, professional expertise, and cultural perspectives, with meaningful gender representation and leadership that reflects the diversity of our broader community.</li>
          </ul>
          <p className="caption" style={{marginTop: '1rem'}}>
            This section reflects ongoing internal work and program observations gathered through grant reporting and operational review during 2025.
          </p>
        </div>
        <div className="edi-sidecar">
          <div className="callout-dark edi-callout">
            <h3>Looking Ahead</h3>
            <p style={{marginBottom: '1rem'}}>Our EDI priorities for 2026:</p>
            <ul style={{color: 'var(--gallery-paper)'}}>
              <li>Develop formal EDI policy and reporting framework</li>
              <li>Increase partnerships with equity-deserving communities</li>
              <li>Continue board and leadership conversations about representation, access, and accountability</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// ================================================
// FINANCIAL OVERVIEW (Page 1 of 2)
// ================================================
function FinancialOverview() {
  // Revenue pie chart data (CSS conic-gradient)
  // Events 53%, Studios 33%, Grants 7%, Donations 2%, Sales & Other 5%
  const revenuePieStyle = {
    width: '220px',
    height: '220px',
    borderRadius: '50%',
    background: `conic-gradient(
      var(--neon-cyan) 0% 53%,
      var(--neon-magenta) 53% 86%,
      #7c5cbf 86% 93%,
      #f5a623 93% 95%,
      var(--steel) 95% 100%
    )`,
    margin: '0 auto 1rem',
    position: 'relative',
  };

  const pieCenter = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  };

  return (
    <section className="section page-break">
      <p className="section-label">Financial Report</p>
      <h2>2025 Financial Overview</h2>

      <div className="grid grid--2 financial-summary" style={{marginBottom: '1.5rem'}}>
        <div className="stat-card stat-card--anchored">
          <p className="stat-number financial-summary__number">$1.31M</p>
          <p className="stat-label">Total Revenue</p>
        </div>
        <div className="stat-card stat-card--anchored">
          <p className="stat-number financial-summary__number">$1.30M</p>
          <p className="stat-label">Total Expenses</p>
        </div>
      </div>

      <div className="grid grid--2 financial-detail-grid" style={{marginBottom: '2rem'}}>
        <div className="financial-panel financial-panel--chart">
          <h3 style={{textAlign: 'center', marginBottom: '1rem'}}>Revenue by Source</h3>
          <div style={revenuePieStyle}>
            <div style={pieCenter}>
              <span style={{fontSize: '1.25rem', fontWeight: 700, color: 'var(--ink-dark)'}}>$1.31M</span>
            </div>
          </div>
          <div className="chart-legend-grid" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.875rem'}}>
            <div><span style={{color: 'var(--neon-cyan)'}}>■</span> Events & Venues <strong>53%</strong></div>
            <div><span style={{color: 'var(--neon-magenta)'}}>■</span> Studio Rentals <strong>33%</strong></div>
            <div><span style={{color: '#7c5cbf'}}>■</span> Government Grants <strong>7%</strong></div>
            <div><span style={{color: 'var(--steel)'}}>■</span> Sales & Other <strong>5%</strong></div>
            <div><span style={{color: '#f5a623'}}>■</span> Donations <strong>2%</strong></div>
          </div>
        </div>

        <div className="financial-panel financial-panel--table">
          <h3>Revenue</h3>
          <table>
            <tbody>
              <tr>
                <td>Events & Venues</td>
                <td style={{textAlign: 'right'}}><strong>$697,507</strong></td>
              </tr>
              <tr>
                <td>Studio Rentals</td>
                <td style={{textAlign: 'right'}}><strong>$429,491</strong></td>
              </tr>
              <tr>
                <td>Government Grants</td>
                <td style={{textAlign: 'right'}}><strong>$90,211</strong></td>
              </tr>
              <tr>
                <td>Sales & Other Earned</td>
                <td style={{textAlign: 'right'}}><strong>$61,669</strong></td>
              </tr>
              <tr>
                <td>Private Donations</td>
                <td style={{textAlign: 'right'}}><strong>$31,913</strong></td>
              </tr>
              <tr style={{borderTop: '2px solid var(--steel)'}}>
                <td><strong>Total Revenue</strong></td>
                <td style={{textAlign: 'right'}}><strong>$1,310,791</strong></td>
              </tr>
            </tbody>
          </table>

          <h3 style={{marginTop: '1.5rem'}}>Expenses</h3>
          <table>
            <tbody>
              <tr>
                <td>Facilities & Occupancy</td>
                <td style={{textAlign: 'right'}}><strong>$565,803</strong></td>
              </tr>
              <tr>
                <td>Event Operations</td>
                <td style={{textAlign: 'right'}}><strong>$308,505</strong></td>
              </tr>
              <tr>
                <td>Personnel</td>
                <td style={{textAlign: 'right'}}><strong>$286,029</strong></td>
              </tr>
              <tr>
                <td>Administration</td>
                <td style={{textAlign: 'right'}}><strong>$103,606</strong></td>
              </tr>
              <tr>
                <td>Marketing & Outreach</td>
                <td style={{textAlign: 'right'}}><strong>$32,091</strong></td>
              </tr>
              <tr style={{borderTop: '2px solid var(--steel)'}}>
                <td><strong>Total Expenses</strong></td>
                <td style={{textAlign: 'right'}}><strong>$1,296,034</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p className="caption financial-disclaimer">
        <em>2025 figures are preliminary and subject to completion of review engagement (expected May 2026).</em>
      </p>
    </section>
  );
}

// ================================================
// FINANCIAL POSITION & SUSTAINABILITY (Page 2 of 2)
// ================================================
function FinancialExpenses() {
  // Expense pie chart
  const expensePieStyle = {
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    background: `conic-gradient(
      var(--neon-magenta) 0% 44%,
      var(--neon-cyan) 44% 68%,
      #7c5cbf 68% 90%,
      #f5a623 90% 98%,
      var(--steel) 98% 100%
    )`,
    margin: '0 auto',
  };

  return (
    <section className="section section--cream page-break">
      <p className="section-label">Financial Report</p>
      <h2>Financial Position</h2>

      <div className="grid grid--2 financial-position-grid" style={{marginBottom: '2rem'}}>
        <div>
          <div className="callout-dark" style={{marginBottom: '1.5rem'}}>
            <h3 style={{color: 'var(--neon-cyan)', marginBottom: '0.5rem'}}>Earned Revenue Ratio</h3>
            <p className="stat-number" style={{fontSize: '3.5rem', marginBottom: '0.25rem'}}>88%</p>
            <p style={{fontSize: '0.95rem', color: 'var(--gallery-paper)'}}>
              Of total revenue comes from events, studio rentals, and sales — demonstrating
              strong organizational self-sufficiency.
            </p>
          </div>
          <p style={{fontSize: '0.95rem'}}>
            Beaumont operates a hybrid financial model: earned revenue from events and
            studio rentals sustains daily operations, while contributed revenue — grants
            and donations — protects access and supports mission-driven programming.
          </p>
        </div>

        <div className="financial-panel financial-panel--chart financial-panel--cream">
          <h3 style={{textAlign: 'center', marginBottom: '1rem'}}>Where Expenses Go</h3>
          <div style={expensePieStyle}></div>
          <div className="chart-legend-grid" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.875rem', marginTop: '1rem'}}>
            <div><span style={{color: 'var(--neon-magenta)'}}>■</span> Facilities <strong>44%</strong></div>
            <div><span style={{color: 'var(--neon-cyan)'}}>■</span> Events <strong>24%</strong></div>
            <div><span style={{color: '#7c5cbf'}}>■</span> Personnel <strong>22%</strong></div>
            <div><span style={{color: '#f5a623'}}>■</span> Admin <strong>8%</strong></div>
            <div><span style={{color: 'var(--steel)'}}>■</span> Marketing <strong>2%</strong></div>
          </div>
        </div>
      </div>

      <div className="callout-dark financial-position-copy">
        <h3 style={{color: 'var(--neon-cyan)', marginBottom: '0.75rem'}}>Understanding Our Financial Position</h3>
        <p style={{color: 'var(--gallery-paper)', marginBottom: '0.75rem'}}>
          Beaumont ended 2025 with a net income of approximately <strong>$15K</strong>. While modest,
          this marks an important milestone: the organization finished the year in positive
          territory despite carrying a <strong>cumulative deficit</strong> from prior years. Every year
          in the black brings Beaumont closer to eliminating that historical balance.
        </p>
        <p style={{color: 'var(--gallery-paper)', marginBottom: '0.75rem'}}>
          A significant contributor to this year's result is the ongoing GST savings from
          Beaumont's new charitable registration, which took effect in 2025 and will
          continue to benefit operations in future years. The year also included routine
          accounting adjustments related to prior-period balances. Excluding these items,
          Beaumont's core operations are approaching break-even, a sign of growing
          financial stability.
        </p>
        <p style={{color: 'var(--gallery-paper)'}}>
          With charitable status now secured, Beaumont is positioned to expand fundraising,
          pursue foundation grants, and work steadily toward eliminating the cumulative
          deficit and building the financial resilience needed for the years ahead.
        </p>
      </div>

      <p className="caption financial-disclaimer" style={{marginTop: '1rem'}}>
        <em>2025 figures are preliminary and subject to completion of review engagement (expected May 2026).</em>
      </p>
    </section>
  );
}

// ================================================
// FINANCIAL VISUALIZATION (removed - consolidated above)
// ================================================
function FinancialVisualization() {
  return null;
}

// ================================================
// LOOKING AHEAD (Capital Campaign)
// ================================================
function LookingAhead() {
  return (
    <section className="section section--dark page-break">
      <p className="section-label" style={{color: 'var(--neon-cyan)'}}>Looking Ahead</p>
      <h2>Securing Beaumont's Future</h2>

      <div className="grid grid--2">
        <div>
          <p style={{color: 'var(--gallery-paper)', fontSize: '1.125rem'}}>
            2026 marks the beginning of Beaumont's most ambitious project: securing
            our long-term future through a capital campaign.
          </p>
          <p style={{color: 'var(--gallery-paper)'}}>
            Our current building is slated for redevelopment, with a timeline of 5–7 years.
            Rather than wait for displacement, we're planning proactively: our goal is to 
            purchase a permanent home for Beaumont.
          </p>
          <p style={{color: 'var(--gallery-paper)'}}>
            We've engaged M3 Consultants to lead a feasibility study and help us map
            the path forward. Our new charitable status unlocks foundation funding
            and tax-receipted donations to support this critical work.
          </p>

          <h3 style={{marginTop: '2rem', color: 'var(--neon-cyan)'}}>Why This Matters</h3>
          <p style={{color: 'var(--gallery-paper)'}}>
            Vancouver has already lost 400,000+ sq ft of artist studio space. Beaumont's
            45 studios represent irreplaceable cultural infrastructure. Securing our
            future means protecting a vital piece of Vancouver's arts ecosystem for
            generations to come.
          </p>
        </div>
        <div>
          <div className="stat-card stat-card--centered" style={{marginBottom: '2rem', backgroundColor: 'var(--concrete-mid)', padding: '2rem', borderRadius: '0'}}>
            <p className="stat-number" style={{fontSize: '4rem'}}>5–7</p>
            <p className="stat-label">Year Timeline</p>
          </div>

          <div className="callout-dark" style={{backgroundColor: 'var(--concrete-mid)'}}>
            <h3 style={{color: 'var(--neon-cyan)'}}>Capital Campaign Goals</h3>
            <ul style={{color: 'var(--gallery-paper)'}}>
              <li>Long-term lease security</li>
              <li>Critical building improvements</li>
              <li>Expanded programming capacity</li>
              <li>Accessibility upgrades</li>
              <li>Operational sustainability</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// BOARD AND STAFF
// ================================================
function BoardAndStaff() {
  const board = [
    { name: 'Gavyn Backus', role: 'President', photo: gavynPhoto },
    { name: 'Brad Godin', role: 'Director', photo: bradPhoto },
    { name: 'Daniela Ugarte', role: 'Director', note: 'Appointed 2025', photo: danielaPhoto },
    { name: 'Naureen Ali', role: 'Director', note: 'Appointed 2025', photo: naureenPhoto },
    { name: 'Justin Davis', role: 'Treasurer', photo: justinPhoto },
    { name: 'Emily Davies', role: 'Director', photo: emilyPhoto },
    { name: 'Todd Wautier', role: 'Director', note: 'Retired 2025', photo: toddPhoto, retired: true },
  ];

  const staff = [
    { name: 'Jude Kusnierz', role: 'Executive Director' },
    { name: 'Luke Summers', role: 'Operations Director' },
    { name: 'Martyna Tyszko', role: 'Bookings & Events Manager' },
    { name: 'Susan Holden', role: 'Grant Writer' },
    { name: 'Ciele Beau', role: 'Gallery Manager' },
    { name: 'Nicole Fontaine', role: 'Beaumont V!ntage Manager' },
    { name: 'Jamal Hamadeh', role: 'B-Side Radio Manager' },
  ];

  return (
    <section className="section page-break">
      <p className="section-label">Governance</p>
      <h2>Board of Directors</h2>
      <div className="board-grid" style={{marginBottom: '3rem'}}>
        {board.map((member, index) => (
          <div key={index} className={`board-member${member.retired ? ' board-member--retired' : ''}`}>
            <img
              src={member.photo}
              alt={member.name}
              className="board-member__photo"
            />
            <p className="board-member__name">{member.name}</p>
            <p className="board-member__role">{member.role}</p>
            {member.note && <p className="board-member__note">{member.note}</p>}
          </div>
        ))}
      </div>

      <p className="section-label">Team</p>
      <h3>Staff</h3>
      <div className="team-list">
        {staff.map((member, index) => (
          <div key={index} className="team-member">
            <span className="team-member__name">{member.name}</span>
            <span className="team-member__role">
              {member.role}
              {member.type && <span style={{color: 'var(--ink-muted)'}}> • {member.type}</span>}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}

// ================================================
// FUNDERS
// ================================================
// ================================================
// VOLUNTEER RECOGNITION
// ================================================
function VolunteerRecognition() {
  return (
    <section className="section volunteer-section">
      <h2>Our Volunteers</h2>

      <div className="grid grid--2">
        <div>
          <p style={{fontSize: '1.125rem', marginBottom: '1rem'}}>
            Beaumont Studios is powered by an extraordinary community of volunteers
            who give their time, energy, and skills to bring our programming to life.
          </p>
          <p>
            From installing gallery exhibitions and running our annual Halloween spectacular
            to staffing Open Studios weekends and supporting the day-to-day operations of
            Beaumont V!ntage, our volunteers are essential to everything we do.
          </p>
          <p>
            In 2025, we were fortunate to draw on a dedicated pool of approximately
            140 active volunteers who collectively contributed an estimated
            <strong> 500+ hours</strong> of service across events, programming,
            and operations.
          </p>
        </div>
        <div className="stat-rail">
          <div className="stat-card stat-card--centered stat-card--anchored" style={{marginBottom: '1.5rem'}}>
            <p className="stat-number" style={{fontSize: '3.5rem'}}>~140</p>
            <p className="stat-label">Active Volunteers</p>
          </div>
          <div className="stat-card stat-card--centered stat-card--anchored">
            <p className="stat-number" style={{fontSize: '3.5rem'}}>500+</p>
            <p className="stat-label">Volunteer Hours</p>
          </div>
        </div>
      </div>

      <div className="pull-quote" style={{marginTop: '2rem'}}>
        <p className="pull-quote__text">
          To every volunteer who showed up, pitched in, and helped make the impossible
          possible — thank you. Beaumont wouldn't be Beaumont without you.
        </p>
      </div>
    </section>
  );
}

// ================================================
// FUNDERS & PARTNERS
// ================================================
function Funders() {
  const partnerLogos = [
    { src: process.env.PUBLIC_URL + '/images/logos/bc-province.png', alt: 'Province of British Columbia' },
    { src: process.env.PUBLIC_URL + '/images/logos/city-of-vancouver.webp', alt: 'City of Vancouver' },
    { src: mercuryArtistsLogo, alt: 'Mercury Artists logo' },
    { src: kiplingLogo, alt: 'Kipling logo' },
    { src: focusEventsLogo, alt: 'Focus Events logo' },
    { src: getFundraisingLogo, alt: 'Get Fundraising logo' },
  ];

  return (
    <section className="section section--cream">
      <p className="section-label">Thank You</p>
      <h2>Our Funders & Partners</h2>

      <div className="partner-logo-grid" style={{marginBottom: '2.75rem'}}>
        {partnerLogos.map((logo, index) => (
          <div key={index} className="partner-logo-tile">
            <img
              src={logo.src}
              alt={logo.alt}
              className="partner-logo-image"
            />
          </div>
        ))}
      </div>

      <div className="grid grid--2">
        <div>
          <h3 style={{fontSize: '1rem', marginBottom: '1rem'}}>Government Funders</h3>
          <p><strong>BC Gaming</strong></p>
          <p style={{marginBottom: '1rem'}}>Supporting Gallery Exhibition Program, Open House, Immersive Theatre, Radio Program, and Boutique</p>

          <p><strong>City of Vancouver</strong></p>
          <ul>
            <li>Affordable Spaces Grant</li>
            <li>Small Capital Grant</li>
            <li>Transit Shelter Advertising (in-kind)</li>
          </ul>
        </div>

        <div>
          <h3 style={{fontSize: '1rem', marginBottom: '1rem'}}>Community Partners</h3>
          <p>
            Vancouver International Film Festival<br />
            5X Festival<br />
            City of Vancouver Cultural Services
          </p>

          <h3 style={{fontSize: '1rem', marginTop: '2rem', marginBottom: '1rem'}}>How Philanthropic Support Helps</h3>
          <ul>
            <li>Protects below-market studio space for working artists</li>
            <li>Helps us keep community programming accessible</li>
            <li>Builds the reserves and planning capacity needed for Beaumont's permanent future</li>
          </ul>

          <div className="pull-quote" style={{marginTop: '2rem'}}>
            <p className="pull-quote__text">
              Thank you to the artists, hosts, producers, funders, donors, and community members who make
              the Beaumont what it is.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// CALL TO ACTION
// ================================================
function CallToAction() {
  return (
    <section className="section section--cream page-break" style={{marginBottom: '3rem'}}>
      <p className="section-label" style={{color: 'var(--neon-cyan)'}}>Get Involved</p>
      <h2>Support Beaumont Studios</h2>

      <div className="grid grid--2">
        <div>
          <p style={{fontSize: '1.125rem'}}>
            As a newly registered charity, your support makes a direct impact on
            Vancouver's arts community. Every contribution helps us maintain affordable
            studio space, sustain cultural programming, and strengthen Beaumont's path toward a permanent home.
          </p>

          <h3 style={{marginTop: '2rem'}}>Ways to Support</h3>
          <ul>
            <li><strong>Make a One-Time Gift</strong> — Contribute directly through our charitable donation page and receive a tax receipt</li>
            <li><strong>Become a Monthly Donor</strong> — Provide steady support that helps us plan programming and operations with confidence</li>
            <li><strong>Explore Major or Legacy Giving</strong> — Connect with Beaumont about larger contributions that support long-term cultural infrastructure</li>
            <li><strong>Become a Partner</strong> — Support Beaumont through sponsorships, rentals, and collaborative initiatives</li>
            <li><strong>Attend and Share</strong> — Join our events, follow the work, and introduce Beaumont to people who care about Vancouver's cultural future</li>
          </ul>
        </div>

        <div>
          <div style={{backgroundColor: 'var(--concrete-deep)', color: 'var(--gallery-paper)', textAlign: 'center', padding: '2rem'}}>
            <h3 style={{color: 'var(--neon-cyan)'}}>Give to Beaumont</h3>
            <p style={{fontSize: '1.5rem', marginBottom: '1rem'}}>thebeaumontstudios.com</p>
            <p style={{marginBottom: '0.75rem'}}>@thebeaumontstudios</p>
            <div style={{textAlign: 'left', margin: '1.5rem 0', padding: '1rem', border: '1px solid var(--steel)'}}>
              <p style={{marginBottom: '0.75rem'}}><strong>One-time and monthly giving:</strong><br />
                <a href="https://thebeaumontstudios.com/contribute/" target="_blank" rel="noreferrer" style={{color: 'var(--neon-cyan)'}}>thebeaumontstudios.com/contribute</a>
              </p>
              <p style={{marginBottom: 0}}><strong>Partnerships and larger gifts:</strong><br />Reach out through the Beaumont website to start the conversation.</p>
            </div>
            <p className="caption" style={{color: '#AAAAAA'}}>
              18K Instagram • 8K Facebook • 11.5K Newsletter
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

// ================================================
// FOOTER
// ================================================
function Footer() {
  return (
    <footer className="footer" style={{textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
      <p className="footer__logo">The Beaumont Studios</p>
      <p className="footer__info">316 & 326 West 5th Avenue</p>
      <p className="footer__info">Vancouver, BC V5Y 1J5</p>
      <div className="footer__links">
        <a className="footer__link" href="https://thebeaumontstudios.com/contribute/" target="_blank" rel="noreferrer">Donate</a>
        <a className="footer__link" href="https://thebeaumontstudios.com/volunteer/" target="_blank" rel="noreferrer">Volunteer</a>
        <a className="footer__link" href="https://thebeaumontstudios.com/sponsorship/" target="_blank" rel="noreferrer">Sponsorship</a>
      </div>
    </footer>
  );
}

export default App;
